/**
 * Supabase Client Configuration
 * 
 * Creates and exports a Supabase client for authentication.
 * The Supabase URL and anon key should be provided via environment variables.
 */

import { createClient } from '@supabase/supabase-js';

// Get Supabase configuration from environment variables
// These should be set at build time via REACT_APP_* prefix
// Create React App only reads .env files at startup - restart dev server after adding variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Supabase credentials not configured. Authentication will not work.');
  console.error('   Missing:', !supabaseUrl ? 'REACT_APP_SUPABASE_URL' : '', !supabaseAnonKey ? 'REACT_APP_SUPABASE_ANON_KEY' : '');
  console.error('   Add these to cascade-react-client/.env file and restart the dev server:');
  console.error('   REACT_APP_SUPABASE_URL=https://your-project.supabase.co');
  console.error('   REACT_APP_SUPABASE_ANON_KEY=your-anon-key-here');
}

// Create Supabase client with fallback empty values to prevent crash
// The client will fail at runtime if credentials are missing, but won't crash on import
export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key',
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    }
  }
);

// Export for testing or advanced usage
export { supabaseUrl, supabaseAnonKey };
